export default function loadSiteModeratorsProcess({ commit }) {
  commit("SET_SITE_MODERATOR_WORKFLOW");

  return Promise.resolve();
}
